import { Enviroment } from '../constants/enviroment-v2.constant';

export const PANEL_MODULES_BY_CLIENT = {
	AR: { reserve: true, quotation: true, preorder: true, qfCriterion: true },
	CL: { reserve: true, quotation: true, preorder: true, qfCriterion: true },
	CLNARMA: { reserve: false, quotation: true, preorder: true, qfCriterion: true },
	MX: { reserve: true, quotation: false, preorder: false, qfCriterion: false },
	CLANICX: { reserve: false, quotation: false, preorder: false, qfCriterion: true },
	CLGREEN: { reserve: false, quotation: true, preorder: true, qfCriterion: true },
	CLZUPHARMA: { reserve: false, quotation: false, preorder: true, qfCriterion: true },
};

export const isPanelModuleEnabled = (module) =>
	PANEL_MODULES_BY_CLIENT[Enviroment.COUNTRY]?.[module] ?? false;
